import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import { API_ROOT, Endpoints } from '../../../../api/Constants';
import { generateUUID } from '../../../../utils/generateUUID';
import store from '../../../store';
import { HEADER, METRICS } from '../utils/constants';
import { saveMetrics } from '../utils/metrics';
import { dispatchRestartSession, getRequestData } from '../utils/performance';
import { restartSessionActive, skipEventError } from '../utils/validations';
import { setupCache } from 'axios-cache-adapter';
import handleInterceptors from '../utils/handlerInterceptors';
import environmentVariables from '../../../../utils/environmentVariables';
var cache = setupCache({
  maxAge: 5000
});
var AxiosInstance = axios.create({
  baseURL: API_ROOT(),
  adapter: cache.adapter
});
AxiosInstance.interceptors.request.use( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
    var _config$data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return restartSessionActive(config);

          case 2:
            if (!_context.sent) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            if (!((_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.raw)) {
              config.headers.Authentication = store.getState().token.token;
              config.headers[HEADER.SESSION_ID] = store.getState().token.token;
              config.headers[HEADER.REQUEST_ID] = generateUUID();
              config.headers[HEADER.LANGUAGE] = environmentVariables.LANGUAGE;
            }

            config.data = getRequestData(config.data);
            saveMetrics[METRICS.REQUEST_SENT](config);
            return _context.abrupt("return", config);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  return Promise.reject(error);
});
AxiosInstance.interceptors.response.use(function (response) {
  saveMetrics[METRICS.RESPONSE_RECEIVED](response);
  handleInterceptors(response.data);
  return response.data;
}, function (error) {
  var _error$response, _error$response2, _error$response2$data;

  var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
  if ((status === 401 || status === 403) && error.config.url !== Endpoints.RESTART_SESSION && error.config.url !== Endpoints.GEO_CHECK) dispatchRestartSession(error);
  !skipEventError((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.errorType) && saveMetrics[METRICS.REQUEST_CATCH](error);
  return Promise.reject(error);
});
export default AxiosInstance;